module.exports = __webpack_public_path__ + "static/hackathon-3-ea60b607c63a76230b90ddff0ee3e46e.jpg";